/**
 * @module
 * @category Component
 */

import { Skeleton } from 'BomdisoftComponents/skeletons/skeleton';

type ChipSkeletonProps = {
  width?: number;
  height?: number;
  variant?: 'circular' | 'rectangular' | 'rounded';
};

export const ChipSkeleton = ({ width = 100, height = 32, variant = 'rounded' }: ChipSkeletonProps) => <Skeleton className='bomdisoft-skeleton-chip' height={height} variant={variant} width={width} />;
